export default __webpack_public_path__ + "static/media/goopter-popular-use-case-casinos.55ab6c2b.jpg";